<template>
  <div class="card">
    <div class="agent-id">AGENT :: {{ agent.id }}</div>

    <div class="avatar-wrap">
      <div class="ring"></div>
      <div class="particle p1"></div>
      <div class="particle p2"></div>
      <div class="particle p3"></div>

      <div class="avatar" :style="{ backgroundImage: `url(${agent.img})` }"></div>
      <span class="online-dot"></span>
    </div>

    <h3 class="name">{{ agent.name }}</h3>
    <div class="role">{{ agent.role }}</div>
    <div class="deco-dots"><span></span><span></span></div>

    <span class="corner top-left"></span>
    <span class="corner top-right"></span>
    <span class="corner bottom-left"></span>
    <span class="corner bottom-right"></span>
  </div>
</template>

<script>
export default {
  props: {
    agent: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.card {
  position: relative;
  background: #0d1117;
  border: 1px solid #253045;
  border-radius: 8px;
  padding: 25px 15px;
  text-align: center;
  cursor: pointer;
  transition: transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1),
    border-color 0.3s ease,
    box-shadow 0.3s ease;
}

.card:hover {
  transform: translateY(-8px) scale(1.02);
  border-color: #4fd1c5;
  box-shadow: 0 15px 30px rgba(79, 209, 197, 0.1);
}

.corner {
  position: absolute;
  width: 10px;
  height: 10px;
  border: 0px solid #4fd1c5;
  opacity: 0;
  transition: all 0.3s ease;
}

.card:hover .corner {
  opacity: 1;
}

.top-left {
  top: 5px;
  left: 5px;
  border-top-width: 2px;
  border-left-width: 2px;
  border-top-left-radius: 4px;
}

.top-right {
  top: 5px;
  right: 5px;
  border-top-width: 2px;
  border-right-width: 2px;
  border-top-right-radius: 4px;
}

.bottom-left {
  bottom: 5px;
  left: 5px;
  border-bottom-width: 2px;
  border-left-width: 2px;
  border-bottom-left-radius: 4px;
}

.bottom-right {
  bottom: 5px;
  right: 5px;
  border-bottom-width: 2px;
  border-right-width: 2px;
  border-bottom-right-radius: 4px;
}

.agent-id {
  font-family: monospace;
  color: #64748b;
  font-size: 0.75rem;
  letter-spacing: 1px;
  margin-bottom: 12px;
  text-align: center;
}

.name {
  color: #fff;
  font-size: 1.1rem;
  margin: 0 0 15px;
  text-align: center;
}

.avatar-wrap {
  position: relative;
  width: 100px;
  height: 100px;
  margin: 0 auto 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.ring {
  position: absolute;
  top: -5px;
  left: -5px;
  right: -5px;
  bottom: -5px;
  border-radius: 50%;
  border: 1px dashed transparent;
  border-top-color: #4fd1c5;
  border-right-color: #4fd1c5;
  animation: spin 2s linear infinite;
  pointer-events: none;
}

.particle {
  position: absolute;
  width: 5px;
  height: 5px;
  background: #8be9fd;
  border-radius: 50%;
  box-shadow: 0 0 8px #8be9fd;
  animation: spin 3s linear infinite reverse;
  pointer-events: none;
}

.p1 {
  top: 5px;
  left: 50%;
}

.p2 {
  bottom: 5px;
  left: 30%;
}

.p3 {
  bottom: 15px;
  right: 20%;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.avatar {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-size: cover;
  background-position: center;
  background-color: #1f2937;
  border: 1px solid #4fd1c5;
  box-shadow: 0 0 10px rgba(79, 209, 197, 0.15);
  background-image: linear-gradient(135deg, #333 0%, #111 100%);
  z-index: 1;
}

.online-dot {
  position: absolute;
  bottom: 5px;
  right: 5px;
  width: 10px;
  height: 10px;
  background-color: #4fd1c5;
  border-radius: 50%;
  border: 2px solid #0d1117;
  z-index: 2;
}

.role {
  color: #4fd1c5;
  font-size: 0.75rem;
  font-family: monospace;
  font-weight: bold;
  margin-bottom: 12px;
}

.deco-dots span {
  display: inline-block;
  width: 8px;
  height: 3px;
  background-color: #4fd1c5;
  margin: 0 3px;
  opacity: 0.5;
}

.deco-dots span:last-child {
  opacity: 1;
}
</style>